import { FilterValues } from "./FilterValuesCollection";

export type ContainerType = "default" | "sold";

export interface HttpQueryParameters {
    q?: string;
    category?: string;
}

export interface HashProductListFilterValues {
    page: number;
    pagesCount: number;
    orderBy: string;
    filter: FilterValues;
}

export interface ProductListFilterValues {
    page: number;
    pagesCount: number;
    orderBy: string;
    browser: string;
    filter: FilterValues;
    pageUrl: string;
    httpQueryParams: HttpQueryParameters;
    containerType: ContainerType;
}

export default class ProductListFilter {
    private page = 1;
    private pagesCount = 1;
    private orderBy: string;
    private filter: FilterValues;
    private readonly httpQueryParams: HttpQueryParameters;
    private readonly browser: string;
    private readonly containerType: ContainerType;

    constructor(orderBy: string, browser: string, containerType: ContainerType, filter: FilterValues, httpQueryParameters: HttpQueryParameters) {
        this.orderBy = orderBy;
        this.browser = browser;
        this.containerType = containerType;
        this.filter = filter;
        this.httpQueryParams = httpQueryParameters;
    }

    public getFilterValues(): FilterValues {
        return this.filter;
    }

    public toJSON(): ProductListFilterValues {
        return {
            pageUrl: globalThis.location.pathname,
            page: this.page,
            pagesCount: this.pagesCount,
            orderBy: this.orderBy,
            browser: this.browser,
            filter: this.filter,
            httpQueryParams: this.httpQueryParams,
            containerType: this.containerType,
        };
    }

    public toJSONForUrlHash(): HashProductListFilterValues {
        return {
            filter: this.filter,
            page: this.page,
            pagesCount: this.pagesCount,
            orderBy: this.orderBy,
        };
    }

    public fromJSONByUrlHash(parsedHash: HashProductListFilterValues): void {
        this.filter = parsedHash.filter;
        this.page = parsedHash.page;
        this.pagesCount = parsedHash.pagesCount;
        this.orderBy = parsedHash.orderBy;
    }

    public setSearchQueryValue(searchQuery: string): void {
        this.filter.SearchQuery = searchQuery.trim() === "" ? undefined : searchQuery;
        this.page = 1;
    }

    public getSearchQueryValue(): string {
        return this.filter.SearchQuery ?? "";
    }

    public removePriceRangeValue(): void {
        this.filter.PriceRange = undefined;
    }

    public removePackageProducer(packageProducerId: number): void {
        this.filter.Producers = this.filter.Producers?.filter((producer) => producer !== packageProducerId);

        if (this.filter.Producers?.length === 0) {
            this.filter.Producers = undefined;
        }
    }

    public removeBookAuthor(bookAuthorId: number): void {
        this.filter.BookAuthors = this.filter.BookAuthors?.filter((author) => author !== bookAuthorId);

        if (this.filter.BookAuthors?.length === 0) {
            this.filter.BookAuthors = undefined;
        }
    }

    public removeProductStatus(productStatusId: number): void {
        this.filter.ProductStatus = this.filter.ProductStatus?.filter((status) => status !== productStatusId);

        if (this.filter.ProductStatus?.length === 0) {
            this.filter.ProductStatus = undefined;
        }
    }

    public removeSellTag(sellTag: number): void {
        if (this.filter.SellTags === undefined) {
            return;
        }

        // eslint-disable-next-line no-bitwise
        this.filter.SellTags = this.filter.SellTags & ~sellTag;

        if (this.filter.SellTags === 0) {
            this.filter.SellTags = undefined;
        }
    }

    public removeInStock(inStock: number): void {
        // eslint-disable-next-line no-bitwise
        this.filter.InStock = this.filter.InStock === undefined ? undefined : this.filter.InStock & ~inStock;
    }

    public removeSubcategory(packageCategoryId: number): void {
        this.filter.Subcategories = this.filter.Subcategories?.filter((subcategory) => subcategory !== packageCategoryId);

        if (this.filter.Subcategories?.length === 0) {
            this.filter.Subcategories = undefined;
        }
    }

    public removeParameter(parameterId: number, parameterValue: number): void {
        if (this.filter.Parameters === undefined) {
            return;
        }

        this.filter.Parameters[parameterId] = this.filter.Parameters[parameterId].filter((value) => value !== parameterValue);
    }

    public removeAllFilters(): void {
        this.filter = {};
    }

    public setSort(orderBy: string): void {
        this.orderBy = orderBy;
    }

    public setPage(page: number): void {
        this.page = page;
        this.pagesCount = 1;
    }

    public setFilterValues(filter: FilterValues): void {
        this.filter = filter;
    }

    public increasePagesCount(): void {
        this.pagesCount++;
    }
}
